import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@RankHR/People/commands-core'
import { isRef, ref, Ref } from 'vue'

export function useAddPersonCommandV1(
	id?: string | Ref<string> | (() => string), 
	regionId?: string | Ref<string> | (() => string), 
	email?: string | Ref<string> | (() => string), 
	displayName?: string | Ref<string> | (() => string), 
	criteriaName?: string | Ref<string> | (() => string), 
	scaleName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>((typeof regionId === 'function') ? regionId() : regionId)
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)
	const _displayName = isRef<string>(displayName) ? displayName : ref<string>((typeof displayName === 'function') ? displayName() : displayName)
	const _criteriaName = isRef<string>(criteriaName) ? criteriaName : ref<string>((typeof criteriaName === 'function') ? criteriaName() : criteriaName)
	const _scaleName = isRef<string>(scaleName) ? scaleName : ref<string>((typeof scaleName === 'function') ? scaleName() : scaleName)

	const result = {
		id: _id,
		regionId: _regionId,
		email: _email,
		displayName: _displayName,
		criteriaName: _criteriaName,
		scaleName: _scaleName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof regionId === 'function') { _regionId.value = regionId() }
			if (typeof email === 'function') { _email.value = email() }
			if (typeof displayName === 'function') { _displayName.value = displayName() }
			if (typeof criteriaName === 'function') { _criteriaName.value = criteriaName() }
			if (typeof scaleName === 'function') { _scaleName.value = scaleName() }

			return new c.AddPersonCommandV1(_id.value, _regionId.value, _email.value, _displayName.value, _criteriaName.value, _scaleName.value)
		})
	}

	return {
		...result,
		authorizedAddPersonCommandV1: result.authorized,
		addPersonCommandV1: result.command,
		completedAddPersonCommandV1: result.completed,
		errorAddPersonCommandV1: result.error,
		invokeAddPersonCommandV1: result.invoke,
		invokingAddPersonCommandV1: result.invoking,
		succeedAddPersonCommandV1: result.succeed,
		validationErrorsAddPersonCommandV1: result.validationErrors,
		onSucceedAddPersonCommandV1: result.onSucceed,
	}
}

export function useCopyPersonVotesCommandV1(
	id?: string | Ref<string> | (() => string), 
	sourceVotingCycle?: string | Ref<string> | (() => string), 
	destVotingCycle?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _sourceVotingCycle = isRef<string>(sourceVotingCycle) ? sourceVotingCycle : ref<string>((typeof sourceVotingCycle === 'function') ? sourceVotingCycle() : sourceVotingCycle)
	const _destVotingCycle = isRef<string>(destVotingCycle) ? destVotingCycle : ref<string>((typeof destVotingCycle === 'function') ? destVotingCycle() : destVotingCycle)

	const result = {
		id: _id,
		sourceVotingCycle: _sourceVotingCycle,
		destVotingCycle: _destVotingCycle,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof sourceVotingCycle === 'function') { _sourceVotingCycle.value = sourceVotingCycle() }
			if (typeof destVotingCycle === 'function') { _destVotingCycle.value = destVotingCycle() }

			return new c.CopyPersonVotesCommandV1(_id.value, _sourceVotingCycle.value, _destVotingCycle.value)
		})
	}

	return {
		...result,
		authorizedCopyPersonVotesCommandV1: result.authorized,
		copyPersonVotesCommandV1: result.command,
		completedCopyPersonVotesCommandV1: result.completed,
		errorCopyPersonVotesCommandV1: result.error,
		invokeCopyPersonVotesCommandV1: result.invoke,
		invokingCopyPersonVotesCommandV1: result.invoking,
		succeedCopyPersonVotesCommandV1: result.succeed,
		validationErrorsCopyPersonVotesCommandV1: result.validationErrors,
		onSucceedCopyPersonVotesCommandV1: result.onSucceed,
	}
}

export function useDisablePersonCommandV1(
	id?: string | Ref<string> | (() => string), 
	regionId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>((typeof regionId === 'function') ? regionId() : regionId)

	const result = {
		id: _id,
		regionId: _regionId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof regionId === 'function') { _regionId.value = regionId() }

			return new c.DisablePersonCommandV1(_id.value, _regionId.value)
		})
	}

	return {
		...result,
		authorizedDisablePersonCommandV1: result.authorized,
		disablePersonCommandV1: result.command,
		completedDisablePersonCommandV1: result.completed,
		errorDisablePersonCommandV1: result.error,
		invokeDisablePersonCommandV1: result.invoke,
		invokingDisablePersonCommandV1: result.invoking,
		succeedDisablePersonCommandV1: result.succeed,
		validationErrorsDisablePersonCommandV1: result.validationErrors,
		onSucceedDisablePersonCommandV1: result.onSucceed,
	}
}

export function useEnablePersonCommandV1(
	id?: string | Ref<string> | (() => string), 
	regionId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>((typeof regionId === 'function') ? regionId() : regionId)

	const result = {
		id: _id,
		regionId: _regionId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof regionId === 'function') { _regionId.value = regionId() }

			return new c.EnablePersonCommandV1(_id.value, _regionId.value)
		})
	}

	return {
		...result,
		authorizedEnablePersonCommandV1: result.authorized,
		enablePersonCommandV1: result.command,
		completedEnablePersonCommandV1: result.completed,
		errorEnablePersonCommandV1: result.error,
		invokeEnablePersonCommandV1: result.invoke,
		invokingEnablePersonCommandV1: result.invoking,
		succeedEnablePersonCommandV1: result.succeed,
		validationErrorsEnablePersonCommandV1: result.validationErrors,
		onSucceedEnablePersonCommandV1: result.onSucceed,
	}
}

export function usePersonVotedCommandV1(
	id?: string | Ref<string> | (() => string), 
	votes?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _votes = isRef<any>(votes) ? votes : ref<any>((typeof votes === 'function') ? votes() : votes)

	const result = {
		id: _id,
		votes: _votes,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof votes === 'function') { _votes.value = votes() }

			return new c.PersonVotedCommandV1(_id.value, _votes.value)
		})
	}

	return {
		...result,
		authorizedPersonVotedCommandV1: result.authorized,
		personVotedCommandV1: result.command,
		completedPersonVotedCommandV1: result.completed,
		errorPersonVotedCommandV1: result.error,
		invokePersonVotedCommandV1: result.invoke,
		invokingPersonVotedCommandV1: result.invoking,
		succeedPersonVotedCommandV1: result.succeed,
		validationErrorsPersonVotedCommandV1: result.validationErrors,
		onSucceedPersonVotedCommandV1: result.onSucceed,
	}
}

export function useUpdatePersonCommandV1(
	id?: string | Ref<string> | (() => string), 
	regionId?: string | Ref<string> | (() => string), 
	email?: string | Ref<string> | (() => string), 
	displayName?: string | Ref<string> | (() => string), 
	criteriaName?: string | Ref<string> | (() => string), 
	scaleName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>((typeof regionId === 'function') ? regionId() : regionId)
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)
	const _displayName = isRef<string>(displayName) ? displayName : ref<string>((typeof displayName === 'function') ? displayName() : displayName)
	const _criteriaName = isRef<string>(criteriaName) ? criteriaName : ref<string>((typeof criteriaName === 'function') ? criteriaName() : criteriaName)
	const _scaleName = isRef<string>(scaleName) ? scaleName : ref<string>((typeof scaleName === 'function') ? scaleName() : scaleName)

	const result = {
		id: _id,
		regionId: _regionId,
		email: _email,
		displayName: _displayName,
		criteriaName: _criteriaName,
		scaleName: _scaleName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof regionId === 'function') { _regionId.value = regionId() }
			if (typeof email === 'function') { _email.value = email() }
			if (typeof displayName === 'function') { _displayName.value = displayName() }
			if (typeof criteriaName === 'function') { _criteriaName.value = criteriaName() }
			if (typeof scaleName === 'function') { _scaleName.value = scaleName() }

			return new c.UpdatePersonCommandV1(_id.value, _regionId.value, _email.value, _displayName.value, _criteriaName.value, _scaleName.value)
		})
	}

	return {
		...result,
		authorizedUpdatePersonCommandV1: result.authorized,
		updatePersonCommandV1: result.command,
		completedUpdatePersonCommandV1: result.completed,
		errorUpdatePersonCommandV1: result.error,
		invokeUpdatePersonCommandV1: result.invoke,
		invokingUpdatePersonCommandV1: result.invoking,
		succeedUpdatePersonCommandV1: result.succeed,
		validationErrorsUpdatePersonCommandV1: result.validationErrors,
		onSucceedUpdatePersonCommandV1: result.onSucceed,
	}
}

